module.exports = __webpack_public_path__ + "img/2.79878d9e.jpg";